import { SettingOutlined } from '@ant-design/icons';
import { useStore } from '../store/store';
import { CONFIGURATOR_LOCK_ID } from './lockIds';

// Bannière affichée quand un co-éditeur configure le document (verrou
// reserved:configurator). Pendant ce temps toute édition et création de box
// est gelée (cf. structureLocks.configuratorHolder / editFreezeHolder) :
// la bannière explique pourquoi les actions sont indisponibles.
export const ConfiguratorBanner = () => {
  const holder = useStore(({ boxLocks, user }) => {
    const lock = boxLocks[CONFIGURATOR_LOCK_ID];
    return lock && lock.id !== user?.id ? lock : null;
  });

  if (!holder) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 64,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 2000,
        backgroundColor: holder.color ?? '#9C27B0',
        color: '#fff',
        padding: '6px 16px',
        borderRadius: 4,
        boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
      }}
    >
      <SettingOutlined spin />
      <span>{holder.name} configure le document…</span>
    </div>
  );
};

export default ConfiguratorBanner;
